export const leftMainTitle = "SOW Design Preferences";

export const leftMainSubtitle = "Get the design and layout you want, and avoid change orders!";

export const leftMainBody =
  "Once the site survey is completed, the SOW Design Team will begin optimizing the sold system design and make sure it complies with the project’s AHJ and Utility specific requirements. Please discuss the following questions with the homeowner, as well as any Scope, Design, Layout or Equipment preferences that our SOW Design Team should consider when creating the final SOW layout.";

export const questionOne =
  "Should the SOW Design Team improve the module layout's production and aesthetics (if possible), or keep it the same?";

export const questionTwo = "Should the SOW Design Team utilize street-facing roof surfaces during optimization?";

export const questionThree =
  "Please provide preferences or requests regarding the system's Scope, Design, Layout, or Equipment.";
